import React, { createContext, useContext } from "react";

/**
 * Context for the current flight row when editing (from list row or API).
 * Provided only on Create/Edit Flight page. Consume via useFlightEditRow().
 * - Create mode: value is null.
 * - Edit mode: value is the flight object (row or fetchedRow).
 */
const FlightEditContext = createContext(null);

export const FlightEditProvider = ({ value, children }) => (
  <FlightEditContext.Provider value={value ?? null}>{children}</FlightEditContext.Provider>
);

export const useFlightEditRow = () => useContext(FlightEditContext);
